import React, { createContext, useCallback, useContext, useMemo, } from 'react';
import { getLabel } from '../utils/index.js';
export const LabelContext = createContext({});
export const LabelContextProvider = ({ children, brand, }) => {
    const getLabelFromContext = useCallback((path = '', ...data) => getLabel(path, brand, ...data), [brand]);
    const value = useMemo(() => ({ getLabelFromContext }), [getLabelFromContext]);
    return (React.createElement(LabelContext.Provider, { value: value }, children));
};
export const useLabelContext = () => {
    const labelContext = useContext(LabelContext);
    if (!labelContext) {
        throw new Error('idv config must be used within a provider');
    }
    return labelContext;
};
//# sourceMappingURL=LabelContext.js.map